import { RefObject, useEffect } from 'react';
import { isReferenceDefined } from './use-click-outside.logic';

type ListenerEvent = MouseEvent | TouchEvent;

export function useClickOutside<T extends HTMLElement = HTMLElement>(
    reference: RefObject<T>,
    callback: (event: ListenerEvent) => void
) {
    useEffect(() => {
        const listener = (event: ListenerEvent) => {
            if (isReferenceDefined(reference, event)) {
                callback(event);
            }
        };

        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);

        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [reference, callback]);
}
